import type { Simplify } from 'type-fest';

import type { ITimestamp } from '../../types/common';

import type { OIDCProviderScope } from './oidcprovider';

export const MAX_AUDIENCES = 100;

export type OIDCTrustRelationshipClaim = Array<{
  claim: string;
  value: string | number | boolean;
  hasWildcards: boolean;
}>;

export type OIDCTrustRelationship = {
  id: number;
  organizationId: number;
  userId: number;
  providerId: number;
  scope: OIDCProviderScope;
  scopeId: number;
  audiences: string[];
  requiredClaims: OIDCTrustRelationshipClaim;
} & ITimestamp;

export type CreateTrustRelationshipRequest =
  Simplify<{
    userId: number;
    providerId: number;
    audiences: string[];
    requiredClaims: Array<{
      claim: string;
      value: string | number | boolean;
      hasWildcards: boolean;
    }>;
  } & (
    {
      scope: OIDCProviderScope.ORG;
    }| {
      scope: OIDCProviderScope.TEAM;
      scopeId: number;
    }
  )>;
